import styled from "@emotion/styled";
import Link from "next/link";

import { fontMerriweather, fontRoboto, setFullViewportWidthStyles, theme } from "shared/lib/styles";

import FooterLogo from "./footer-logo.svg";
import HeaderLogo from "./header-logo.svg";

export const HeaderLogoLink = styled(Link)`
  display: block;

  margin-inline: auto;
  padding-block: 24px;

  ${theme.breakpoints.up("tablet")} {
    padding-block: 60px;
  }
`;
export const StyledHeaderLogo = styled(HeaderLogo)`
  display: block;

  max-inline-size: 207px;
  margin-inline: auto;

  ${theme.breakpoints.up("tablet")} {
    max-inline-size: 360px;
  }
`;

export const PageContainer = styled.div`
  background-color: #222222;

  ${setFullViewportWidthStyles()};
`;

export const Wrapper = styled.div`
  max-inline-size: 980px;
  margin-inline: auto;
`;

export const TitleContainer = styled.div`
  margin-block-end: 24px;
  padding-block: 0;
  padding-inline: 20px;

  ${theme.breakpoints.up("tablet")} {
    margin-block-end: 60px;
    padding-block: 0;
    padding-inline: 60px;
  }
`;

export const Title = styled.div`
  margin-block-end: 20px;

  color: #ffffff;
  font-weight: 300;
  font-size: 32px;
  font-family: ${fontMerriweather};
  line-height: 140%; /* 67.2px */
  text-align: center;

  ${theme.breakpoints.up("tablet")} {
    font-size: 48px;
  }
`;

export const Description = styled.div`
  color: #a1a1a1;
  font-size: 16px;
  font-family: ${fontMerriweather};
  line-height: 140%; /* 25.2px */
  text-align: center;

  font-variant-numeric: lining-nums proportional-nums;

  ${theme.breakpoints.up("tablet")} {
    font-size: 18px;
  }
`;

export const ListsContainer = styled.div`
  display: flex;
  flex-flow: column wrap;
  gap: 40px;
  justify-content: center;
  align-items: center;

  ${theme.breakpoints.up("tablet")} {
    flex-direction: row;
    gap: 60px 40px;
    align-items: flex-start;

    max-inline-size: 640px;
    margin-inline: auto;
  }

  ${theme.breakpoints.up("desktop")} {
    max-inline-size: 980px;
  }
`;

export const ListImage = styled.img`
  inline-size: 100%;
  block-size: auto;

  object-fit: cover;
`;

export const ListTitle = styled.div`
  color: #a1a1a1;
  font-size: 20px;
  font-family: ${fontMerriweather};
  line-height: 130%;
  letter-spacing: 0;
  text-align: center;
`;

type ListLinkProps = {
  $disabled?: boolean;
};

export const ListLink = styled.div<ListLinkProps>`
  padding-block: 8px;
  padding-inline: 14px;

  font-size: 14px;
  font-family: ${fontRoboto};
  line-height: 100%;
  letter-spacing: 0;
  text-align: center;
  text-transform: uppercase;

  border: 1px solid #ffffff;
  border-radius: 2px;

  background-color: #ffffff;

  transition: ease-in-out 0.3s;

  ${props =>
    props.$disabled &&
    `
    opacity: 0.5;
    cursor: not-allowed;
  `}
`;

type ListItemProps = {
  $disabled?: boolean;
};

export const ListItem = styled.div<ListItemProps>`
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;

  max-inline-size: 300px;

  cursor: ${props => (props.$disabled ? "not-allowed" : "pointer")};

  &:hover {
    ${ListLink} {
      background-color: ${props => (props.$disabled ? "#ffffff" : "#e5e5e5")};
    }
  }
`;

export const BottomLink = styled(Link)`
  display: block;

  max-inline-size: 271px;
  margin-block: 40px;
  margin-inline: auto;

  color: #ffffff;
  font-size: 18px;
  font-family: ${fontMerriweather};
  line-height: 130%; /* 23.4px */
  text-align: center;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: none;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;

  &:hover {
    text-decoration: none;
  }

  ${theme.breakpoints.up("tablet")} {
    max-inline-size: none;
    margin-block: 60px;
  }
`;

export const FooterContainer = styled.div`
  padding-block-end: 60px;
  border-block-start: 1px solid #999999;

  ${theme.breakpoints.up("tablet")} {
    padding-block-end: 0;
  }
`;

export const FooterWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  max-inline-size: 1070px;
  margin-block: 0;
  margin-inline: auto;
  padding: 24px;

  ${theme.breakpoints.up("tablet")} {
    flex-direction: row;
    justify-content: space-between;

    padding-block: 25px;
  }
`;

export const FooterLogoLink = styled(Link)`
  margin-block-end: 20px;

  ${theme.breakpoints.up("tablet")} {
    margin-block-end: 0;
  }
`;

export const StyledFooterLogo = styled(FooterLogo)``;

export const FooterTnc = styled.div`
  color: #ffffff;
  font-size: 13px;
  font-family: ${fontRoboto};
  line-height: 28px;

  ${theme.breakpoints.up("tablet")} {
    margin-block-start: 0;
  }
`;
